export const ASSETS = {
  IMAGES: {
    IMG_LONDON: "/assets/images/london.jpg",
    PRACTITIONER_AVATAR: "/assets/images/practitioner-avatar.png",
    LOGIN_IMAGE: "/assets/images/therapy.png",
    LOGO: "/assets/images/Logo.png",
    LOGO_LIGHT: "/assets/images/Logo-Light.png",
    ADMIN_DASHBOARD_LOGO: "/assets/images/admin-dash-logo.png",
    PROFILE_BACKGROUND: "/assets/images/profile-bg.jpg",
    PLACEHOLDER_PROFILE_PIC: "/assets/images/placeholder-profile-pic.jpg",
    CLOCK: "/assets/images/clock.gif",
    PDF_PLACEHOLDER: "/assets/images/pdf.png",
  },
};

// export { default as LoginImage } from "./assets/images/therapy.png";
// export { default as Logo } from "./assets/images/Logo.png";
// export { default as LogoLight } from "./assets/images/Logo-Light.png";
// export { default as pracAvatar } from "./assets/images/prac_avatar.jpg";
// export { default as admin_dash_logo } from "./assets/images/admin-dash-logo.png";
